import React from "react";
import "./App.css";
import Signup from "./components/Signup";

function App() {
  return (
    <div className="App">
      <Signup />
    </div>
  );
}

export default App;
